(function() { window.GUID_c357ee65_be8f_4821_a343_af74b6935211 = { getGuid: function() { return "c357ee65-be8f-4821-a343-af74b6935211"; } }; })();
//namespace CS.Controls {
//    export abstract class Container extends ControlBase {
//        private $container: JQuery;
//        public Parameters: any[];
//        public get ControlId(): string {
//            return this.$container.attr('id');
//        }
//        public get $Control(): JQuery {
//            return this.$container;
//        }
//        protected OnControlInstantiation(params: any[]) {
//            this.$container = $('#' + params[0]);//contient le Id
//            this.Parameters = params;
//            this.OnControlInstantiated();
//        }
//        public abstract OnControlInstantiated();
//    }
//}

//# sourceMappingURL=container.js.map
